var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isRender) ? _c('contract-paper', {
    attrs: {
      "loader": !_vm.isFetchedFileTypes,
      "isFilled": _vm.isFilled,
      "contractLink": _vm.main,
      "contractFiles": _vm.contract,
      "ogrnFiles": _vm.ogrn,
      "onUpload": _vm.upload
    },
    on: {
      "remove": _vm.handleRemove
    }
  }) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-571df4ba","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/contractPaper/ContractPaperContainer.vue
// module id = 919
// module chunks = 0